import { Collection } from 'modules/core/lib/mobx-rest'

import type Location from 'modules/locations/store/models/Location'
import CompanyHoliday from 'modules/timeoff/store/models/CompanyHoliday'

class CompanyHolidays extends Collection<CompanyHoliday> {
  model() {
    return CompanyHoliday
  }

  filterByRangeAndLocation(
    locationsIds: number[],
    startAt: moment.Moment,
    endAt: moment.Moment
  ): CompanyHoliday[] {
    return this.filter(
      (holiday) =>
        locationsIds.includes(holiday.attributes.location_id) &&
        holiday.parsedDate.isBetween(startAt, endAt, undefined, '[]')
    )
  }
}

const singleton: CompanyHolidays = new CompanyHolidays()

export const locationHolidays = (location: Location) => {
  return singleton.filter({
    location_id: location.attributes.id,
  })
}

export default singleton
